import Heading from "./Heading";

export default function Results({ answers, results, ctaHeading, ctaContent, ctaLinkOne, ctaLinkTwo }) {
    // Variable to hold the result
    let resultContent = '';
    let showCTA = true;
    // Variable to hold the number of questions where the user agreed with the statement
    let agreedCount = answers.slice(1).filter((answer) => answer === 'Agree');

    if (answers[0] === 'Disagree') {
        resultContent = results.question_one_false;
    } else {
        switch (agreedCount.length) {
            case 4:
                resultContent = results.all_true;
                break;
            case 3:
                resultContent = results.all_bar_one_true;
                break;
            case 2:
                resultContent = results.two_true;
                break;
            default:
                showCTA = false;
                resultContent = results.one_true;
                break;
        }
    }

    return (
        <div className="test__results">
            {results?.result_heading && (
                <Heading>
                    {results.result_heading}
                </Heading>
            )}

            {resultContent && <p className="test__content">{resultContent}</p>}

            {(!showCTA && results?.all_tests) && <a className="btn btn--outline test__result-button" href={results.all_tests}>Back to all tests</a>}

            {showCTA && ctaHeading && ctaContent && (
                <div className="test__cta">
                    <h2 className="test__cta-heading">{ctaHeading}</h2>

                    <p className="test__cta-content">
                        {ctaContent}
                    </p>

                    {(ctaLinkOne?.url || ctaLinkTwo?.url) && (
                        <div className="test__cta-buttons">
                            {ctaLinkOne?.url && (
                                <a className="btn btn--primary test__cta-button" href={ctaLinkOne.url} target={ctaLinkOne?.target ?? ''}>
                                    {ctaLinkOne?.title ?? ''}
                                </a>
                            )}
                            {ctaLinkTwo?.url && (
                                <a className="btn btn--monotone test__cta-button" href={ctaLinkTwo.url} target={ctaLinkTwo?.target ?? ''}>
                                    {ctaLinkTwo?.title ?? ''}
                                </a>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}